import React from 'react'
import { Button, Popper, Box, Paper } from '@mui/material';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import PublicIcon from '@mui/icons-material/Public';
import logo from '../assets/Blizzard_.svg.png';
import Typography from '@mui/material/Typography';
import ClickAwayListener from '@mui/material/ClickAwayListener';
function Footer() {


    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const navBlizzard = () => {
        window.open('https://www.blizzard.com/fr-fr/', '_blank')
    }
    return (
        <footer className='footer'>
            <div className='langague'>
                <Button
                    sx={{ color: 'white' }}
                    className='footer__language-button'
                    aria-controls="language-menu"
                    aria-haspopup="true"
                    onClick={(event) => handleOpen(event)}
                    startIcon={<PublicIcon sx={{ color: '#009dff' }} />}
                    endIcon={<UnfoldMoreIcon sx={{ color: '#009dff' }} />}
                >
                    Français
                </Button>
                <Popper
                    open={Boolean(anchorEl)} anchorEl={anchorEl} placement="top" onClose={handleClose}

                >
                    <ClickAwayListener onClickAway={handleClose}>

                        <Paper sx={{ borderRadius: '20px' }}>
                            <Box className='langage-modal'>
                                <div className='list_langage' >
                                    <Typography className='item-langage'>English (US)</Typography>
                                    <Typography className='item-langage'>Deutsch</Typography>
                                    <Typography className='item-langage'>English (EU)</Typography>
                                    <Typography className='item-langage'>English (SEA)</Typography>
                                    <Typography className='item-langage'>Español (EU)</Typography>
                                    <Typography className='item-langage'>Español (Latino)</Typography>
                                    <Typography className='item-langage'>Français</Typography>
                                    <Typography className='item-langage'>Italiano</Typography>
                                </div>
                                <div className='list_langage'>
                                    <Typography className='item-langage'>한국어</Typography>
                                    <Typography className='item-langage'>Polski</Typography>
                                    <Typography className='item-langage'>Português (Brasil)</Typography>
                                    <Typography className='item-langage'>Русский</Typography>
                                    <Typography className='item-langage'>简体中文</Typography>
                                    <Typography className='item-langage'>ภาษาไทย</Typography>
                                    <Typography className='item-langage'>日本語</Typography>
                                </div>
                            </Box>
                        </Paper>
                    </ClickAwayListener>
                </Popper>
            </div>
            <div className='logo'>
                <img className='logo-img' src={logo} onClick={navBlizzard} alt='logo' />
            </div>
            <div className='links'>
                <div className='link-item'>
                    OFFRES D'EMPLOI
                </div>
                <div className='link-item'>
                    A PROPOS DE NOUS
                </div>
                <div className='link-item'>
                    ASSISTANCE
                </div>
                <div className='link-item'>
                    NOUS CONTACTER
                </div>
                <div className='link-item'>
                    PRESSE
                </div>
                <div className='link-item'>
                    API
                </div>
                <div className='link-item'>
                    PLAN DU SITE
                </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                <Typography color="#d8d8d8" paragraph align="center">Une seule application pour tous les jeux: <a className='download-link-footer' rel='noreferrer' href='https://www.blizzard.com/fr-fr/apps/battle.net/desktop' target='_blank'>Application de bureau Battle.net</a> </Typography>
            </div>

            <div className='footer-marque'>
                <Typography paragraph mb={0} sx={{ fontSize: '12px', color: "#d8d8d8" }} align='center'>©2023 Blizzard Entertainment, Inc. Tous droits réservés.</Typography>
                <Typography paragraph sx={{ fontSize: '12px', color: "#d8d8d8" }} align='center'>Toutes les <span className='mark'>marques</span> citées appartiennent à leurs propriétaires respectifs.</Typography>
            </div>
            <div className='links-mention'>
                <div className='link-mention-item'>
                    Confidentialité en ligne
                </div>
                <div className='link-mention-item'>
                    Informations légales
                </div>
                <div className='link-mention-item'>
                    Mentions légales
                </div>
                <div className='link-mention-item'>
                    Politique relative aux cookies
                </div>
                <div className='link-mention-item'>
                    Paramètres de cookies
                </div>

            </div>
        </footer >
    )
}

export default Footer